























































































/* 
  接口说明
  getSubject 科目管理接口
  saveOrUpdate 添加或者编辑科目信息
  deleteSubject 删除科目
*/
import { Vue, Component } from "vue-property-decorator";
import {
  getSubject,
  saveOrUpdate,
  deleteSubject
} from "../../../api/subjectManage";
import { Form as ElForm } from "element-ui";
import { ruleNormal, rulePattern } from "../../../utils/common";

@Component({
  name: "subjectManage"
})
export default class extends Vue {
  private showTableLoading: boolean = false; //是否显示列表loading
  private tableData: object[] = []; //列表数据
  private chooseIdArray: string[] = []; //勾选的数据id集合
  private dialogFormVisible: boolean = false; //是否显示添加\编辑弹窗
  private editType: string = ""; //记录是 "添加" 还是 "修改"
  private editForm: object = {}; //添加\编辑弹窗的数据
  private dialogFormTitle: string = ""; //弹窗标题
  private editFormRules: object = {
    subjectCode: [
      ruleNormal("请输入科目编号"),
      rulePattern(/^[\w]{1,12}$/, "12位以内数字科目编号")
    ],
    subjectName: [
      ruleNormal("请输入科目名称"),
      rulePattern(/^[\u4e00-\u9fa5\-]{1,24}$/, "24位以内汉字科目名称")
    ],
    subjectAbbre: [
      ruleNormal("请输入科目简称"),
      rulePattern(/^[\u4e00-\u9fa5\-]{1,16}$/, "16位以内汉字科目简称")
    ]
  };

  created() {
    //获取列表
    this.getData();
  }

  //获取列表数据
  private async getData() {
    this.showTableLoading = true;
    try {
      let res = await getSubject();
      this.showTableLoading = false;
      this.tableData = res.data;
    } catch (error) {
      this.showTableLoading = false;
      this.$message.error(error || "获取数据失败");
    }
  }

  //勾选处理
  private selectChangeHandle(v: object[]) {
    this.chooseIdArray = v.map((item: any) => {
      return item.subjectId;
    });
  }

  //点击“添加”或“编辑”弹窗处理
  private showEditDialog(type: string, row?: object) {
    this.dialogFormTitle = type === "add" ? "添加科目" : "编辑科目";
    this.editForm = type === "modify" ? JSON.parse(JSON.stringify(row)) : {};
    //显示弹窗
    this.dialogFormVisible = true;
  }

  //新增/编辑-保存修改处理
  private saveEditHandle() {
    (this.$refs.editForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          await saveOrUpdate(this.editForm);
          this.$message.success("保存成功");
          this.dialogFormVisible = false;
          this.getData();
          (this.$refs.editForm as ElForm).clearValidate();
        } catch (error) {
          this.$message.error(error || "保存失败");
        }
      }
    });
  }
  // 取消
  private handleCancel() {
    (this.$refs.editForm as ElForm).clearValidate();
    this.dialogFormVisible = false;
  }

  //删除处理
  private deleteHandle() {
    if (this.chooseIdArray.length <= 0) {
      this.$message.warning("请先勾选！");
      return;
    }
    //询问是否删除
    this.$confirm("确定删除?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      try {
        await deleteSubject(this.chooseIdArray);
        this.$message.success("删除成功");
        //操作成功，重新获取列表
        this.getData();
      } catch (error) {
        this.$message.error(error || "删除失败");
      }
    });
  }
}
